(() => {
  if (customElements.get('viscena-locator-controller')) return;
  class Locator extends HTMLElement {
    connectedCallback() {
      const root = this.parentElement;
      const cards = Array.from(root.querySelectorAll('[data-dealer]'));
      const input = root.querySelector('[data-search]');
      const frame = root.querySelector('[data-map]');
      const count = root.querySelector('[data-count]');
      const empty = root.querySelector('[data-empty]');
      const normal = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      let active = null;
      const select = card => {
        if (!frame || !card) return;
        cards.forEach(item => {
          const selected = item === card;
          item.classList.toggle('is-selected', selected);
          item.querySelector('[data-show-map]').setAttribute('aria-pressed', String(selected));
        });
        if (active !== card) {
          frame.src = `https://maps.google.com/maps?q=${encodeURIComponent(card.dataset.address)}&output=embed&z=13`;
          frame.title = `Map of ${card.dataset.name}`;
          root.querySelector('[data-map-name]').textContent = card.dataset.name;
          root.querySelector('[data-open-map]').href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(card.dataset.address)}`;
        }
        active = card;
      };
      cards.forEach(card => {
        const button = card.querySelector('[data-show-map]');
        button.hidden = false;
        button.addEventListener('click', () => {
          select(card);
          if (window.matchMedia('(max-width: 749px)').matches) root.querySelector('.vl-map-panel').scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        });
      });
      const filter = () => {
        const terms = normal(input.value).split(' ').filter(Boolean);
        const shown = cards.filter(card => {
          const text = normal(`${card.dataset.name} ${card.dataset.address} ${card.dataset.keywords}`);
          card.hidden = !terms.every(term => text.includes(term));
          return !card.hidden;
        });
        count.textContent = `${shown.length} ${shown.length === 1 ? 'location' : 'locations'}`;
        empty.hidden = shown.length > 0;
        root.querySelector('.vl-map-panel').hidden = cards.length > 0 && shown.length === 0;
        if (shown.length && (!active || active.hidden)) select(shown[0]);
      };
      input.addEventListener('input', filter);
      root.querySelector('[data-search-wrap]').hidden = !cards.length;
      this.onBlock = event => {
        const card = cards.find(item => item.dataset.blockId === event.detail.blockId);
        if (card) { input.value = ''; filter(); select(card); }
      };
      document.addEventListener('shopify:block:select', this.onBlock);
      filter();
    }
    disconnectedCallback() { document.removeEventListener('shopify:block:select', this.onBlock); }
  }
  customElements.define('viscena-locator-controller', Locator);
  const init = scope => scope.querySelectorAll('[data-dealer-locator]').forEach(root => {
    if (!root.querySelector('viscena-locator-controller')) root.appendChild(document.createElement('viscena-locator-controller'));
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
